// import React, { lazy } from 'react'
import '../../App.scss'
import HeroSection from '../../sections/Hero/Hero';
import OurProducts from '../../sections/OurProducts/OurProducts';
import Business from '../../sections/Business/Business';
import ContactUs from '../../sections/ContactUs/ContactUs';
import OurClients from '../../sections/OurClients/OurClients';
import Newsletter from '../../sections/Newsletter/Newsletter';
import Footer from '../../sections/Footer/Footer';
import Whatsapp from '../../components/Whatsapp';
import NavBar from '../../components/NavBar';
import SocialLinks from '../../components/SocialLinks';
import DashboardLogin from '../../sections/DashboardLogin/DashboardLogin';
// import Call from '../../components/Call';
import Referral from "../../sections/Referral/Referral"
// import Facebook from '../../components/Facebook';
// import Team from '../../sections/Team/Team';

// const LazyFacebook = lazy(() => import('../../components/Facebook'))

const HomeScreen = () => {

    return (
        <div>
            <NavBar />
            <HeroSection />
            <OurProducts />
            <Business />
            <Referral />
            <ContactUs />
            <DashboardLogin/>
            <OurClients />
            <Newsletter />
            {/* <Team /> */}
            <Footer />
            <SocialLinks />
            <Whatsapp />
            {/*<Call/>*/}
            {/* <Suspense fallback={<div>Loading...</div>}>
                <LazyFacebook />
            </Suspense> */}
        </div>
    );
}

export default HomeScreen;
